import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SelectSyaryousoujuuryou from 'components/site/select_syaryousoujuuryou'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectSyaryousoujuuryouStart: state.searchFormCondition.selectSyaryousoujuuryouStart,
  selectSyaryousoujuuryouFinish: state.searchFormCondition.selectSyaryousoujuuryouFinish,
})

const SyaryousoujuuryouContainer = connect(mapStateToProps, mapDispatchToProps)(SelectSyaryousoujuuryou)

export default SyaryousoujuuryouContainer
